import { useContext } from 'react';
import { ApprovalContext } from '../context/approvalContext';
export const useApprovalContext = () => useContext(ApprovalContext);